import { make } from './Title.gen'

type TitleProps = React.ComponentProps<typeof make>

const Title = make as React.FunctionComponent<TitleProps>

export { Title, type TitleProps }
